import React, { useState, useEffect } from "react";
import { Input } from "reactstrap";

const Dropdown = ({ handleSelect, values, disabled }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedPlaces, setSelectedPlaces] = useState([]);
  const [isSelectAll, setIsSelectAll] = useState(false);
  const [isSelectAllKIC, setIsSelectAllKIC] = useState(false);
  const [isSelectAllOther, setIsSelectAllOther] = useState(false);
  const options = [
    { value: "KIC越谷", label: "KIC越谷" },
    { value: "KIC狭山日高", label: "KIC狭山日高" },
    { value: "KIC厚木", label: "KIC厚木" },
    { value: "KICあきる野", label: "KICあきる野" },
    { value: "木更津市立岩根中学校", label: "木更津市立岩根中学校" },
    { value: "木更津市立太田中学校", label: "木更津市立太田中学校" },
    { value: "木更津市立富来田中学校", label: "木更津市立富来田中学校" },
    { value: "木更津市立畑沢小学校", label: "木更津市立畑沢小学校" },
    {
      value: "木更津市立木更津第二中学校",
      label: "木更津市立木更津第二中学校",
    },
    { value: "木更津市立請西小学校", label: "木更津市立請西小学校" },
    { value: "木更津市立清見台小学校", label: "木更津市立清見台小学校" },
    {
      value: "北海道銀行",
      label: "北海道銀行",
    },
  ];
  const [selectedPlant, setSelectedPlant] = useState([]);
  const kicOptions =
    options && options.filter((option) => option.label.includes("KIC"));
  const otherOptions =
    options && options.filter((option) => !option.label.includes("KIC"));

  const handleCheckboxChange = (device, isChecked) => {
    const newSelectedDevices = isChecked
      ? [...selectedPlaces, device]
      : selectedPlaces.filter((dev) => dev.value !== device.value);
    setSelectedPlaces(newSelectedDevices);
  };

  const handleSelectAll = () => {
    if (isSelectAll) {
      setSelectedPlaces([]);
    } else {
      setSelectedPlaces(options);
    }
    setIsSelectAll(!isSelectAll);
    setIsSelectAllKIC(!isSelectAll);
    setIsSelectAllOther(!isSelectAll);
  };

  const handleSelectAllGroup = (isKIC) => {
    const groupOptions = options.filter((option) =>
      isKIC ? option.label.includes("KIC") : !option.label.includes("KIC")
    );
    const allSelected = isKIC ? isSelectAllKIC : isSelectAllOther;

    if (allSelected) {
      const newSelectedDevices = selectedPlaces.filter(
        (dev) => !groupOptions.some((option) => option.value === dev.value)
      );
      setSelectedPlaces(newSelectedDevices);
    } else {
      const newSelectedDevices = [
        ...selectedPlaces,
        ...groupOptions.filter(
          (option) => !selectedPlaces.some((dev) => dev.value === option.value)
        ),
      ];
      setSelectedPlaces(newSelectedDevices);
    }

    if (isKIC) {
      setIsSelectAllKIC(!isSelectAllKIC);
    } else {
      setIsSelectAllOther(!isSelectAllOther);
    }
  };

  useEffect(() => {
    const kicOptions = options.filter((option) => option.label.includes("KIC"));
    const otherOptions = options.filter(
      (option) => !option.label.includes("KIC")
    );

    setIsSelectAllKIC(
      kicOptions.every((option) =>
        selectedPlaces.some((dev) => dev.value === option.value)
      )
    );
    setIsSelectAllOther(
      otherOptions.every((option) =>
        selectedPlaces.some((dev) => dev.value === option.value)
      )
    );
    setIsSelectAll(
      options.every((option) =>
        selectedPlaces.some((dev) => dev.value === option.value)
      )
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedPlaces]);

  useEffect(() => {
    if (values === "全発電所") {
      setSelectedPlant(options);
      setSelectedPlaces(options);
    } else if (values === "KIC[全発電所]") {
      setSelectedPlant(
        options.filter((option) => option.label.startsWith("KIC"))
      );
      setSelectedPlaces(
        options.filter((option) => option.label.startsWith("KIC"))
      );
    } else if (values === "木更津SC[全発電所]") {
      setSelectedPlant(
        options.filter((option) => !option.label.startsWith("KIC"))
      );
      setSelectedPlaces(
        options.filter((option) => !option.label.startsWith("KIC"))
      );
    } else if (Array.isArray(values)) {
      const selectedOptions = values
        .map((val) => options.find((option) => option.value === val.value))
        .filter(Boolean);
      setSelectedPlant(selectedOptions);
      setSelectedPlaces(selectedOptions);
    } else {
      const selectedOption = options.find((option) =>
        option.label.includes(values)
      );
      setSelectedPlant(selectedOption ? [selectedOption] : []);
      setSelectedPlaces(selectedOption ? [selectedOption] : []);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values]);

  const textOverFlow = (str) => {
    if (str.length > 40) {
      return `${str.slice(0, 37)}...`;
    } else {
      return str;
    }
  };

  return (
    <div className={`${disabled ? "disable_edit" : ""}`}>
      <div className="notice-input-field mb-3 full-field">
        <label for="name">投稿対象</label>
        <Input
          type="text"
          bsSize="sm"
          className={`remote_time remote__input `}
          placeholder="発電所を選択"
          value={
            selectedPlant.length > 0
              ? selectedPlant.length === options.length
                ? "全発電所"
                : kicOptions.every((option) =>
                    selectedPlant.some((dev) => dev.value === option.value)
                  )
                ? textOverFlow(
                    `KIC[全発電所], ${selectedPlant
                      .filter((option) => !option.label.includes("KIC"))
                      .map((plant) => plant.label)
                      .join(", ")}`
                  )
                : otherOptions.every((option) =>
                    selectedPlant.some((dev) => dev.value === option.value)
                  )
                ? textOverFlow(
                    `木更津SC[全発電所], ${selectedPlant
                      .filter((option) => option.label.includes("KIC"))
                      .map((plant) => plant.label)
                      .join(", ")}`
                  )
                : textOverFlow(
                    selectedPlant.map((plant) => plant.label).join(",")
                  )
              : ""
          }
        />
        <img
          src="/img/down-arrow.png"
          alt="arrow"
          width="25px"
          height="20px"
          className="mr-2 mt-2"
          style={{ cursor: "pointer" }}
          onClick={() => setIsOpen(!isOpen)}
        />
      </div>
      {isOpen && (
        <div className={`select-dropdown ${isOpen && "show"}`}>
          <div
            className="py-1 d-flex align-items-center px-2"
            style={{
              backgroundColor: "#233c6b",
              color: "#fff",
              borderRadius: "3px",
            }}
          >
            <input
              type="checkbox"
              style={{ cursor: "pointer" }}
              onChange={handleSelectAll}
              checked={isSelectAll}
            />
            <div className="pl-1 selectBoxLabel">すべて選択</div>
          </div>
          <div className="dropDown_options ">
            <div className="dropdownBox mt-1">
              <div className="py-1 d-flex align-items-center px-2">
                <input
                  type="checkbox"
                  style={{ cursor: "pointer" }}
                  onChange={() => handleSelectAllGroup(true)}
                  checked={isSelectAllKIC}
                />
                <div className="selectBoxLabel">KIC</div>
              </div>
              <div className="sub-dropDown ml-3">
                {kicOptions.map((device, index) => (
                  <div
                    key={index}
                    className="d-flex align-items-center optionBox px-2"
                  >
                    <input
                      type="checkbox"
                      style={{ cursor: "pointer" }}
                      onChange={(e) =>
                        handleCheckboxChange(device, e.target.checked)
                      }
                      checked={selectedPlaces.some(
                        (dev) => dev.value === device.value
                      )}
                    />
                    <div className=" selectBoxOptions">{device.label}</div>
                  </div>
                ))}
              </div>
            </div>
            <div className="dropdownBox mt-1">
              <div className="py-1 d-flex align-items-center px-2">
                <input
                  type="checkbox"
                  style={{ cursor: "pointer" }}
                  onChange={() => handleSelectAllGroup(false)}
                  checked={isSelectAllOther}
                />
                <div className=" selectBoxLabel">木更津SC</div>
              </div>
              <div className="sub-dropDown ml-3">
                {otherOptions.map((device, index) => (
                  <div
                    key={index}
                    className="d-flex align-items-center optionBox px-2"
                  >
                    <input
                      type="checkbox"
                      style={{ cursor: "pointer" }}
                      onChange={(e) =>
                        handleCheckboxChange(device, e.target.checked)
                      }
                      checked={selectedPlaces.some(
                        (dev) => dev.value === device.value
                      )}
                    />
                    <div className="selectBoxOptions">{device.label}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div style={{ textAlign: "center" }}>
            <button
              className="btn__remotePrimary mt-2"
              onClick={() => {
                setIsOpen(!isOpen);
                setSelectedPlant(selectedPlaces);
                handleSelect(selectedPlaces);
              }}
            >
              OK / 閉じる
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Dropdown;
